import AccountAddressesTable from './AccountAddressesTable'

export default AccountAddressesTable
